<template lang="pug">
  .component-client-action-buttons
    CommonCostButtonModal(:cost="item", @itemUpdated="$emit('itemUpdated')")
      .dropdown-buttons
        button.button Edit
    .dropdown-buttons
      ActionButton(:action="remove", :confirm="true") Delete
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from 'src/maggieHelper'
  import ModalReveal from '../../foundation/ModalReveal'
  import CommonCostButtonModal from './CommonCostButtonModal'
  import ActionButton from '../ActionButton'

  export default {
    name: 'CommonCostButtons',
    components: {ActionButton, CommonCostButtonModal, ModalReveal},
    data() {
      return {
        entity: null
      }
    },
    created() {
    },
    methods: {
      remove: function () {
        return KeplerBackofficeSdk.commonCosts.select(this.item).delete(() => {
          MaggieHelper.notification('delete-esit', 'Cost removed')
          this.$emit('itemUpdated')
        })
      },
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CommonCostButtons.vue?6ce2b2f2